(() => {
 if(window.AndRideSeasons)return;
 const day=86400000;
 const date=(y,m,d)=>new Date(Date.UTC(y,m-1,d));
 const nth=(y,m,weekday,n)=>{const start=date(y,m,1);return date(y,m,1+(weekday-start.getUTCDay()+7)%7+7*(n-1));};
 const last=(y,m,weekday)=>{const end=date(y,m+1,0);return date(y,m,end.getUTCDate()-(end.getUTCDay()-weekday+7)%7);};
 function easter(y){const a=y%19,b=Math.floor(y/100),c=y%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),n=h+l-7*m+114;return date(y,Math.floor(n/31),n%31+1);}
 const eu=new Set('AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE'.split(' '));
 function region(country){const code=String(country||'').toUpperCase();return ['US','CA','GB','GB-SCT','EU'].includes(code)?code:eu.has(code)?'EU':'GLOBAL';}
 function pick(input,country){
  const now=date(input.getFullYear(),input.getMonth()+1,input.getDate()),y=now.getUTCFullYear(),m=now.getUTCMonth()+1,d=now.getUTCDate(),r=region(country);
  const near=(event,before=7,after=0)=>now>=new Date(+event-before*day)&&now<=new Date(+event+after*day);
  const thanksgiving=nth(y,11,4,4),blackFriday=new Date(+thanksgiving+day),cyberMonday=new Date(+blackFriday+3*day);
  if((m===12&&d===31)||(m===1&&d<=7))return'new_year';
  if(near(cyberMonday,0,2))return'cyber_monday';
  if(m===11&&now<=new Date(+blackFriday+2*day))return'black_friday';
  if(m===12&&d<=25)return'christmas';
  if(m===12&&d>=26&&['CA','GB','GB-SCT'].includes(r))return'boxing';
  if(near(date(y,2,14),7))return'valentine';
  if(near(easter(y),10,1))return'easter';
  if(near(date(y,4,22),4))return'earth_day';
  if(r==='US'){
   if(near(nth(y,2,1,3)))return'presidents';
   if(near(last(y,5,1)))return'memorial';
   if(near(date(y,7,4)))return'independence';
   if(near(nth(y,9,1,1)))return'labour';
   if(m===5)return'bike_month';
  }
  if(r==='CA'){
   const before25=date(y,5,24);const victoria=new Date(+before25-((before25.getUTCDay()+6)%7)*day);
   if(near(victoria))return'victoria';
   if(near(date(y,7,1)))return'canada_day';
   if(near(nth(y,9,1,1)))return'labour';
   if(near(nth(y,10,1,2)))return'thanksgiving';
  }
  if(r==='GB'||r==='GB-SCT'){
   const summer=r==='GB-SCT'?nth(y,8,1,1):last(y,8,1);
   if(near(nth(y,5,1,1),4)||near(last(y,5,1),4)||near(summer,7))return'uk_bank';
  }
  if(r==='EU'&&near(date(y,5,1),4))return'may_day';
  if(['US','CA','GB','GB-SCT'].includes(r)&&near(nth(y,6,0,3)))return'father_day';
  if(m===10&&d>=20)return'halloween';
  if((m===8&&d>=15)||(m===9&&d<=5))return'back_school';
  if(m>=9&&m<=10)return'autumn';
  if(m>=6&&m<=8)return'summer';
  if(m>=3&&m<=5)return'spring';
  return'winter';
 }
 function apply(element){
  const requested=element.dataset.seasonMode||'brand';
  const market=element.dataset.seasonRegion==='auto'?(element.dataset.market||'GLOBAL'):element.dataset.seasonRegion;
  const season=requested==='auto'?pick(new Date(),market):requested;
  element.dataset.season=season;
  if(element.dataset.autoBadge==='true'){
   try{const labels=JSON.parse(element.querySelector('[data-deal-season-labels]').textContent),badge=element.querySelector('[data-deal-season-badge]');if(badge&&labels[season])badge.textContent=labels[season];}catch{}
  }
 }
 window.AndRideSeasons={pick,region,easter,apply};
})();
